
interface Location {
	[key: string]: unknown;
	id: number | string | null;
	fkClient: number | string | null;
	title: string;
	enabled: boolean;
	isBrick: boolean;
	hasAtm: boolean;
	description: string;
	branchImage: string | null;
	address1: string;
	address2: string;
	city: string;
	state: string | null;
	zip: string | null;
	latitude: string | number;
	longitude: string | number;
	mailSameAsPhysical: boolean;
	mailAddress1: string;
	mailAddress2: string;
	mailCity: string;
	mailState: string | null;
	mailZip: string | null;
	tags: string[];
	driveThroughSameAsLobby: boolean;
	atm24Hours: boolean;
	phones: Phone[];
	atmHours: Hours[];
	driveThroughHours: Hours[];
	lobbyHours: Hours[];
	type: string | null;
}

interface Hours {
	[key: string]: string;
	name: string;
	value: string;
}

interface Phone {
	[key: string]: string;
	name: string;
	value: string;
}

const loc = {
	id: null,
	fkClient: null,
	title: '',
	description: '',
	branchImage: '',
	hasAtm: false,
	isBrick: true,
	enabled: true,
	address1: '',
	address2: '',
	city: '',
	state: null,
	zip: null,
	latitude: '',
	longitude: '',
	mailSameAsPhysical: false,
	mailAddress1: '',
	mailAddress2: '',
	mailCity: '',
	mailState: null,
	mailZip: null,
	tags: [],
	driveThroughSameAsLobby: false,
	atm24Hours: false,
	phones: [],
	atmHours: [],
	driveThroughHours: [],
	lobbyHours: [],
	type: null
} as Location;

const generateType = function (isBrick: boolean, hasAtm: boolean): string {
	return isBrick && hasAtm ? 'Branch & ATM' : isBrick ? 'Branch' : hasAtm ? 'ATM' : 'No Services';
}

const locationFactory = function (): Location {
	return {
		...loc,
		atmHours: [],
		driveThroughHours: [],
		lobbyHours: [],
		phones: [],
		tags: [],
	} as Location;
}

export default Location;
export {
	locationFactory,
	generateType,
	Hours,
	Phone
}